var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"value":_vm.value,"fetch-suggestions":_vm.querySearch,"placeholder":"请输入收费方式","clearable":_vm.clearable},on:{"input":_vm.change,"select":_vm.handleSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }